var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrade9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1136_12447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6636 4.74009L8.64775 4.15652L6.85181 0.517562C6.77988 0.371867 6.63994 0.298889 6.5 0.298889L6.50052 10.7669L10.0919 12.6552C10.3799 12.8064 10.716 12.5621 10.6611 12.2416L9.97522 8.24172L12.881 5.40918C13.1141 5.18214 12.9854 4.78691 12.6636 4.74009Z",
    fill: "#FFA323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13192 7.96786C9.13192 7.96786 9.75132 11.5783 9.75341 11.5903C9.75132 11.5901 6.55048 10.7795 6.50052 10.7669C6.5 10.7667 2.90812 12.6552 2.90812 12.6552C2.62013 12.8064 2.28402 12.5621 2.33895 12.2416L3.02478 8.24172L0.119002 5.40918C-0.114056 5.18214 0.0146359 4.78691 0.336367 4.74009L4.35225 4.15652L6.14819 0.517562C6.22012 0.371867 6.36006 0.298889 6.5 0.298889L8.1267 4.87375L11.7641 5.40238L9.13192 7.96786Z",
    fill: "#FFD27A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1136_12447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade9);
export default __webpack_public_path__ + "static/media/grade9.a97891ce28db5fd81ce4d3fd00f009df.svg";
export { ForwardRef as ReactComponent };